export const tooltipContentStyles = {
  labelStyle: {
    fontWeight: 600,
    color: '#333',
  },
  valueStyle: {
    color: '#666',
  },
};
